import React, { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import client from "../api";

export default function AuthCallback() {
  const navigate = useNavigate();
  const hasProcessed = useRef(false);

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const hash = window.location.hash || "";
    const m = hash.match(/session_id=([^&]+)/);
    const session_id = m ? decodeURIComponent(m[1]) : null;

    const run = async () => {
      if (!session_id) { navigate("/", { replace: true }); return; }
      try {
        // Customer Google login flow (only flow that uses OAuth callback)
        const { data } = await client.post("/auth/customer/session", { session_id });
        if (data?.token) {
          localStorage.setItem("foodgo_customer_token", data.token);
        }
        if (data?.user) {
          localStorage.setItem("foodgo_customer", JSON.stringify(data.user));
        }
        const slug = sessionStorage.getItem("foodgo_customer_return_slug");
        if (slug) {
          sessionStorage.removeItem("foodgo_customer_return_slug");
          navigate(`/r/${slug}`, { replace: true, state: { justLoggedIn: true } });
        } else {
          navigate("/", { replace: true });
        }
      } catch (e) {
        console.error(e);
        navigate("/", { replace: true });
      }
    };
    run();
  }, [navigate]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-deep">
      <div className="text-center" data-testid="auth-callback-loading">
        <div className="w-12 h-12 rounded-full border-4 border-line border-t-[#00E5FF] animate-spin mx-auto" />
        <p className="mt-4 text-zinc-400 font-mono text-xs uppercase tracking-widest">Autenticazione...</p>
      </div>
    </div>
  );
}
